import { useNavigate } from 'react-router-dom';
import { store } from '../../stateManagement/store';
import { getItemWebStorage, setItemWebStorage } from '../../features/webStorageSaver';
import { useAppSelector } from '../../stateManagement/hooks/redux';
import { IndorImages, getIndorImageSrc } from '../../features';
import { highlightSearchValueInText } from '../../features/textHighlighter/textHighlighter';
import { setSelectedPath } from '../../stateManagement/reducers';
import { classNames } from 'primereact/utils';

const goToMapButtonIconSrc = getIndorImageSrc(IndorImages.Map);

type PathInRoadItem = {
    path: any,
    isInRaion: boolean,
    raionId?: string
}

// Компонент - объект с наименованием дороги и направления на странице "Выбор дорог и направлений"
export function PathInRoadItem({ path, isInRaion, raionId }: PathInRoadItem) {
    const navigate = useNavigate()
    const { selectedPath, idsOfPathsWithGeometry, pathsSearchValue } = useAppSelector(state => state.pathsInfo)
    const { Name: pathName, RoadName: roadName, PathID: pathId, RoadId: roadId } = path ?? {}
    const pathIsActive = selectedPath?.pathId === pathId
    const pathHasGeometry = idsOfPathsWithGeometry?.includes(`${pathId}`)

    function goToMap(event: any) {
        event.stopPropagation();
        navigate(`/app/map/path/${pathId}`)
    }

    function selectPath() {
        const newSelectedPath = { pathName, pathId, roadName, roadId, raionId }
        store.dispatch(setSelectedPath(newSelectedPath))
        const localPathsInfo = getItemWebStorage('pathsInfo')
        const newPathsInfo = { ...localPathsInfo, selectedPath: newSelectedPath }
        setItemWebStorage('pathsInfo', newPathsInfo)
    }

    const pathInRoadClassnames = classNames({
        "roads-list-path-in-road-item": true,
        "in-raion": isInRaion,
        "active": pathIsActive
    })

    return (
        <div tabIndex={pathId} className={pathInRoadClassnames} onClick={selectPath}>
            <span className='path-description'>{highlightSearchValueInText(pathName, pathsSearchValue)}</span>
            <div className='navigation-buttons'>
                {pathHasGeometry &&
                    <img className='go-to-map-button' onClick={goToMap} src={goToMapButtonIconSrc} />
                }
            </div>
        </div>
    )
}

